import PropTypes from 'prop-types';
import classNames from 'classnames';
import { kebabCase } from 'lodash';
import {
  VibeButton,
  viAdd,
  color,
} from 'vibeguide';

function ProviderHeader({
  className = '',
  style = {},
  title,
  showNew = false,
  showRemove = false,
  onClickNew = () => {},
  onClickRemove = () => {},
}) {
  const providerKey = kebabCase(title);
  return (
    <div
      className={classNames('ProviderHeader', className)}
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '16px 24px',
        borderTop: `1px solid ${color.whiteSmoke}`,
        borderBottom: `4px solid ${color.primary}`,
        ...style,
      }}
    >
      <div
        style={{
          flexGrow: 1,
          fontSize: 18,
          fontWeight: 'bold',
          textTransform: 'uppercase',
        }}
      >
        {title}
      </div>

      <div>
        {showNew && (
          <VibeButton
            text="New Config"
            style={{
              marginRight: 16,
            }}
            color="primary"
            icon={viAdd}
            iconProps={{
              style: {
                padding: 0,
              },
            }}
            testId={`provider-${providerKey}-new-config-button`}
            onClick={onClickNew}
          />
        )}

        {showRemove && (
          <VibeButton
            text="Remove Ad Provider"
            color="error"
            testId={`provider-${providerKey}-remove-button`}
            onClick={onClickRemove}
          />
        )}
      </div>
    </div>
  );
}

ProviderHeader.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string.isRequired,
  showNew: PropTypes.bool,
  showRemove: PropTypes.bool,
  onClickNew: PropTypes.func,
  onClickRemove: PropTypes.func,
};

export default ProviderHeader;
